import React from "react";
import {interpolate, useCurrentFrame} from "remotion";
import {techLaunchData} from "../../../data/techLaunchData";


export const Data: React.FC = () => {

  const frame = useCurrentFrame();


  const progress = interpolate(
    frame,
    [0, 120],
    [0, 1],
    {
      extrapolateRight: "clamp",
    }
  );


  const usersNumber = Math.floor(
    1000000 * progress
  );


  const growthNumber = Math.floor(
    320 * progress
  );


  return (

    <div
      style={{
        flex: 1,
        backgroundColor: "#050505",
        color: "white",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >


      <h1
        style={{
          fontSize: 70,
        }}
      >
        数据增长
      </h1>


      <div
        style={{
          display: "flex",
          gap: 100,
          marginTop: 60,
        }}
      >


        <div>

          <div
            style={{
              fontSize: 90,
              fontWeight: 700,
            }}
          >
            {usersNumber.toLocaleString()}
          </div>

          <div
            style={{
              fontSize: 35,
              opacity:0.7,
            }}
          >
            用户数量
          </div>

        </div>



        <div>

          <div
            style={{
              fontSize: 90,
              fontWeight:700,
            }}
          >
            {growthNumber}%
          </div>


          <div
            style={{
              fontSize:35,
              opacity:0.7,
            }}
          >
            增长率
          </div>


        </div>


      </div>


    </div>

  );

};
